export function initFooterReveal({ ScrollTrigger = null, lenis = null } = {}) {
    const root = document.documentElement;
    const footer = document.querySelector('[data-site-footer]');
    const spacer = document.querySelector('[data-footer-reveal-spacer]');

    if (!footer || !spacer) return null;

    let frame = 0;
    let lastHeight = -1;

    const sync = () => {
        frame = 0;
        const height = Math.ceil(footer.getBoundingClientRect().height);
        if (height <= 0 || height === lastHeight) return;

        lastHeight = height;
        spacer.style.height = `${height}px`;
        root.style.setProperty('--led-footer-reveal-height', `${height}px`);
        lenis?.resize?.();
        ScrollTrigger?.refresh?.();
    };

    const requestSync = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(sync);
    };

    const resizeObserver = typeof ResizeObserver === 'function'
        ? new ResizeObserver(requestSync)
        : null;

    resizeObserver?.observe(footer);
    window.addEventListener('resize', requestSync, { passive: true });
    window.addEventListener('load', requestSync, { once: true });
    window.addEventListener('led:themetransitionend', requestSync);
    requestSync();

    return {
        refresh: requestSync,
        destroy() {
            if (frame) window.cancelAnimationFrame(frame);
            resizeObserver?.disconnect();
            window.removeEventListener('resize', requestSync);
            window.removeEventListener('led:themetransitionend', requestSync);
        },
    };
}
